import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { languageOptions } from './entries';

i18n
  .use(HttpApi) // Load translations via HTTP
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    supportedLngs: Object.keys(languageOptions), // Add your 17 languages here
    fallbackLng: 'en', // Default language if no match found
    debug: false, // Enable for debugging during development
    detection: {
      caches: [], // Disable caching
    },
    ns: ['common', 'dashboard', 'edit', 'errors', 'settings', 'sidebar'],
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_I18N_VERSION || '1.1'}`,
    },
  });

export default i18n;